import { IconButton } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';

type Props = {
    href: string;

    // Names the target, since the icon alone does not say what opens.
    label: string;

    // Set when the row has no url yet, as an unsaved resource link does.
    disabled?: boolean;
};

// Opens a lesson, a course or an uploaded file in a new tab.
export default function OpenInNewTabButton({ href, label, disabled = false }: Props) {
    return (
        <IconButton
            component="a"
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label={label}
            size="small"
            disabled={disabled}
        >
            <OpenInNew fontSize="small" />
        </IconButton>
    );
}
